import { XmlInfoDto } from './XmlInfoDto'

export class SendEncryptedOfferResponseDto {
  private _sedeUrl: string
  private _xmlInfo: XmlInfoDto[]

  constructor (sedeUrl: string, xmlInfo: XmlInfoDto[]) {
    this._sedeUrl = sedeUrl
    this._xmlInfo = xmlInfo
  }

  get sedeUrl (): string {
    return this._sedeUrl
  }

  get xmlInfo (): XmlInfoDto[] {
    return this._xmlInfo
  }
}
